<div class="tooltip" [style.left.px]="left" [style.top.px]="top">
  {{ text }}
</div>
